import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PATH_HOME } from 'src/constants/spa-routes';
import { useAppSelector } from 'src/store';
import { useTheme } from 'src/provider/ThemeProvider';
import CreateProjectStep1Page from 'src/pages/ProjectPage/CreateProjectSteps/CreateProjectStep1Page/CreateProjectStep1Page';
import CreateProjectStep2Page from 'src/pages/ProjectPage/CreateProjectSteps/CreateProjectStep2Page/CreateProjectStep2Page';
import CreateProjectStep3Page from 'src/pages/ProjectPage/CreateProjectSteps/CreateProjectStep3Page/CreateProjectStep3Page';
import CreateProjectStep4Page from 'src/pages/ProjectPage/CreateProjectSteps/CreateProjectStep4Page/CreateProjectStep4Page';
import CreateProjectStep5Page from 'src/pages/ProjectPage/CreateProjectSteps/CreateProjectStep5Page/CreateProjectStep5Page';
import CreateProjectStep6Page from 'src/pages/ProjectPage/CreateProjectSteps/CreateProjectStep6Page/CreateProjectStep6Page';
import CreateProjectStep7Page from 'src/pages/ProjectPage/CreateProjectSteps/CreateProjectStep7Page/CreateProjectStep7Page';

export const CreateProjectSteps = () => {
  const { step } = useParams();
  const navigate = useNavigate();
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);
  const { setTheme } = useTheme();

  useEffect(() => {
    setTheme('purple');
  }, []);

  useEffect(() => {
    if (isInactivePlan) {
      navigate(PATH_HOME.ROOT);
    }
  }, [isInactivePlan]);

  switch (step) {
    case '1':
      return <CreateProjectStep1Page />;
    case '2':
      return <CreateProjectStep2Page />;
    case '3':
      return <CreateProjectStep3Page />;
    case '4':
      return <CreateProjectStep4Page />;
    case '5':
      return <CreateProjectStep5Page />;
    case '6':
      return <CreateProjectStep6Page />;
    case '7':
      return <CreateProjectStep7Page />;
  }
};
